import { SfInputFormField, SfTextAreaFormField } from 'ngx-smart-form';
import { combineLatest, startWith, Subject } from 'rxjs';
import { SectionId } from '../configs/section-id-enum';
import { SECTIONS_WITH_NOTES } from '../configs/sections-with-notes';
import { SagittaScoreSectionDto } from '../dto/sagitta-score-section-dto';
import { SagittaScoreArea } from './sagitta-score-area';
import { SagittaScoreElement } from './sagitta-score-element';
import { SagittaScoreFactory } from './sagitta-score-factory';
import { SagittaScoreRow } from './sagitta-score-row';

export class SagittaScoreSection {
  counter$ = new Subject<number>();
  private _total = 0;
  get total() {
    return this._total;
  }
  notes?: SfTextAreaFormField;
  constructor(
    notesFieldValue: string | undefined,
    public id: SectionId,
    public title: string,
    public weight: number,
    public rows: SagittaScoreRow[] = []
  ) {
    if (SECTIONS_WITH_NOTES.includes(id)) {
      this.notes = new SfTextAreaFormField({
        formControlName: `${id}_notes`,
        label: 'Note',
        value: notesFieldValue,
      });
    }

    let sectionElements = this.rows.map((row) => row.elements).flat();
    let kriPointsCounter$ = sectionElements.map((el) => el.kriPoint$);
    combineLatest(kriPointsCounter$)
      .pipe(startWith(sectionElements.map((el) => el.kriPoints)))
      .subscribe((counters) => {
        this.updateTotal(counters);
      });
  }

  updateTotal(counters: number[]) {
    this._total = this.calcTotal(counters);
    this.counter$.next(this._total * (this.weight / 100));
  }

  private calcTotal(counters: number[]) {
    let total = counters.reduce((el, acc) => (acc || 0) + (el || 0));
    return total || 0;
  }

  static genDto(
    section: SagittaScoreSection,
    area: SagittaScoreArea['area']
  ): SagittaScoreSectionDto {
    let scoreSection: SagittaScoreSectionDto = {
      id: section.id,
      score: SagittaScoreFactory.round(section.total) || 0,
      title: section.title,
      weight: section.weight,
      noteFieldsValue: section.notes?.controlRef?.value,
      rows: section.rows.map((row) => {
        return SagittaScoreRow.genDto(row, area);
      }),
    };
    return scoreSection;
  }
}
